import { MarketingNotificationsStatus, User } from '~/types/users'
import { ApiKy } from './index'

export default class Api extends ApiKy {
  getMe() {
    return this.ky.get(`${this.url}/me`)?.json<User>()
  }

  updateMe(payload: Partial<User>) {
    return this.ky.patch(`${this.url}/me`, { json: payload })?.json<User>()
  }

  inviteAdmin(payload: { email: string; role: string }) {
    return this.ky.post(`${this.url}/invite-admin`, { json: payload })
  }

  updateMarketingNotifications(
    marketingNotifications:
      | MarketingNotificationsStatus.ACCEPTED
      | MarketingNotificationsStatus.DECLINED,
  ) {
    return this.ky
      .post(`${this.url}/update-marketing-notifications`, {
        json: { marketingNotifications },
      })
      ?.json<{
        marketingNotifications: MarketingNotificationsStatus
        marketingNotificationsUpdatedAt: string
      }>()
  }
}
